/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG = window.Shopify?.theme?.role === 'development' || window.Shopify?.theme?.role === 'unpublished',
    styles = {
      success: "background:darkgreen;color:white;padding:2px 6px;border-radius:3px",
      error: "background:darkred;color:white;padding:2px 6px;border-radius:3px",
      warning: "background:darkorange;color:white;padding:2px 6px;border-radius:3px",
      info: "background:blue;color:white;padding:2px 6px;border-radius:3px",
      filename: "background:#333;color:#bada55;padding:2px 6px;border-radius:3px;margin-left:4px"
    };

  const getCallerFile = () => {
    try {
      return (new Error().stack.split('\n').find(l => l.includes('/assets/') && !l.includes('/custom_sitewide.js')) || '')
        .match(/\/assets\/([^:?]+)\??/)?.[1] || '';
    } catch (e) { return ''; }
  };

  const log = (...args) => DEBUG && console.log(...args);

  const collapse = (type, data, title = "Log", status = "info") => {
    if (!DEBUG) return;
    const file = getCallerFile();
    console.groupCollapsed(`%c ${title}${file ? ' %c' + file : ''}`,
      styles[status] || styles.info, file ? styles.filename : '');
    type === "table" ? console.table(data) : console.log(data);
    console.groupEnd();
  };

  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);



// Function to copy text to clipboard
function copyToClipboard(text) {
  const tempInput = document.createElement('input');
  document.body.appendChild(tempInput);
  tempInput.value = text;
  tempInput.select();
  document.execCommand('copy');
  document.body.removeChild(tempInput);
}

// Function to show notification popup
function showCopyNotification() {
  const notification = document.createElement('div');
  notification.textContent = 'Copied!';
  notification.style.cssText = `
    position: fixed; top: 20px; right: 20px; background: var(--simple-image-copy-popup-bg); color: var(--simple-image-copy-popup-text);
    padding: 8px 16px; border-radius: 4px; font-size: 13px; z-index: 9999;
    opacity: 0; transform: translateY(-10px); transition: all 0.2s ease; box-shadow: 0 2px 8px rgba(255, 255, 255, 0.1);
  `;

  document.body.appendChild(notification);
  setTimeout(() => notification.style.cssText += 'opacity: 1; transform: translateY(0);', 10);
  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transform = 'translateY(-10px)';
    setTimeout(() => document.body.removeChild(notification), 200);
  }, 1500);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href="#"][title="Copy to Clipboard"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const text = this.dataset.copy;
      copyToClipboard(text);
      showCopyNotification();
      log.collapse({ text, parent: this.parentElement.parentElement }, 'Copied to Clipboard', 'success');
    });
  });
});


$('.faq').click(function(){
  $(this).find('.answer').slideToggle();
});